"use client";

import { TPostLink, TPostMedia } from "@/types/post";
import FeedMediaCarouselUi from "./feed-post-carousel-ui";
import Modal from "@/components/ui/modal";

export const FeedMediaCarouselModal = (props: {
	items: TPostMedia[];
	links: TPostLink[];
	selectedItemIndex: number;
	onCloseModal: () => void;
}) => {
	return (
		<Modal
			className="fixed inset-0 z-50 flex items-center justify-center rounded-none bg-black/80"
			isOpen={true}
			onClose={props.onCloseModal}
		>
			<div onClick={(e) => e.stopPropagation()} className="relative max-h-[90vh] w-full max-w-4xl">
				<FeedMediaCarouselUi
					className="h-full w-full"
					fullScreen={true}
					images={props.items}
					links={props.links}
					startIndex={props.selectedItemIndex}
				/>
			</div>
		</Modal>
	);
};
